import auth from "../../middlewares/auth";
export const settingsQuestionTypeRoute = [
  {
    path: '/settings/question_types',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/question_type/QuestionTypeList'),
    name: 'settings_question_type',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/question_types/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/question_type/QuestionTypeForm'),
    name: 'settings_question_type_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/question_types/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/question_type/QuestionTypeForm'),
    name: 'settings_question_type_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];